import { render, staticRenderFns } from "./Issue4.vue?vue&type=template&id=12bd704e&scoped=true&"
var script = {}
import style0 from "./Issue4.vue?vue&type=style&index=0&id=12bd704e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bd704e",
  null
  
)

export default component.exports